export default __webpack_public_path__ + "maps-examples-light-example-thumbnail-960-cc7feec7ae1f0c458df0adc6644e3e12.png";